import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../Assets/logo.png";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa"; // ← Original icons

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-600 to-blue-800 py-8 text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo and Branding */}
          <div className="mb-6 md:mb-0 flex flex-col items-center md:items-start">
            <div className="flex items-center mb-3">
              <Link to={'/'}>
                <img 
                  src={Logo} 
                  alt="Ascent Abacus Logo" 
                  className="h-12 w-auto mr-3"
                />
              </Link>
              <span className="text-xl font-bold">Ascent Abacus</span>
            </div>
            <p className="text-sm text-white/80">Enhancing brain power through abacus training</p>
          </div>
          
          {/* Quick Links */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-lg font-semibold mb-3 text-center md:text-left">Quick Links</h3>
            <ul className="space-y-2 text-center md:text-left">
              <li><Link to="https://ascentabacus.com/about/" className=" label text-white/80 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="https://ascentabacus.com/" className="label text-white/80 hover:text-white transition-colors">Our Programs</Link></li>
              <li><Link to="https://ascentabacus.com/contact/" className="label text-white/80 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
          
          {/* Social Media Links with Bounce Animation */}
          <div className="flex space-x-6">
            <a 
              href="https://www.facebook.com/ascentabacusbraingym" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors animate-bounce"
              style={{ animationDelay: '0.1s' }}
              aria-label="Facebook"
            >
              <FaFacebookF className="w-6 h-6" />
            </a>
            <a 
              href="https://www.instagram.com/ascent_abacus_brain_gym/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors animate-bounce"
              style={{ animationDelay: '0.3s' }}
              aria-label="Instagram"
            >
              <FaInstagram className="w-6 h-6" />
            </a>
            <a 
              href="https://www.youtube.com/@ASCENTABACUSANDBRAINGYM" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors animate-bounce"
              style={{ animationDelay: '0.5s' }}
              aria-label="YouTube"
            >
              <FaYoutube className="w-6 h-6" />
            </a>
          </div>
        </div>
        
        {/* Copyright Text */}
        <div className="mt-8 pt-6 border-t border-white/20 text-center text-sm text-white/80">
          © 2025 Ascent Abacus and Brain Gym. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
